import script from "./acquaint-textbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-textbox.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-textbox.vue?vue&type=style&index=0&id=5db74b3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db74b3c"]])

export default __exports__